import { orderBy } from "lodash";
import { getCandidateStatusKey } from "../../../../utilities/candidate";

export const isSameSubStatus = (a, b) => {
  return a?.statusId === b?.statusId && a?.id === b?.id;
};

export const sortTransitionsBySubStatus = (
  transitions,
  statusesById,
  subStatusesById,
  { statusIdField, subStatusIdField },
) => {
  return orderBy(
    transitions,
    [
      (t) => statusesById[t[statusIdField]]?.orderId,
      (t) => {
        const subStatusId = getCandidateStatusKey(
          t[statusIdField],
          t[subStatusIdField],
        );

        return subStatusesById[subStatusId]?.orderId;
      },
    ],
    ["asc", "asc"],
  );
};
